import { TextField } from "@mui/material";
import { ReactElement, useState } from "react";

export default function Field(props: any): ReactElement {
  const { label, placeholder } = props;
  const item = localStorage.getItem(label);
  const [value, setValue] = useState(item ?? "");

  return (
    <TextField
      sx={{ mb: "10px" }}
      fullWidth
      variant="outlined"
      label={label ?? ""}
      placeholder={placeholder ?? ""}
      onChange={(e) => {
        setValue(e.target.value);
        localStorage.setItem(label, e.target.value);
      }}
      value={value}
    />
  );
}
